
const initialState = {
  bitcoinTrades: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_BITCOIN_TRADES_DATA': {
      const { bitcoinTrades } = payload;
      return {
        ...state,
        bitcoinTrades,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BitcoinTrades/BitcoinTrades.reducer.js